export class Modal {
	constructor(callBeforeShow) {
		this.elements = this.getModalElements(); // Get modal elements
		this.callbeforeShow = callBeforeShow ?? false; // Set the callbeforeShow Object (if provided)
		this.setupEvents(); // Setup event listeners, initialize modal based on URL hash & detect OS for download modals
		this.current = null; // Track current modal
	}

	/**
	 * Get modal elements and organize them into an object
	 * @returns {Object} An object containing modal elements
	 */
	getModalElements() {
		const container = $("#sf-modal"); // Get the modal container element
		const dialog = {}; // Initialize an empty object to store modal dialogs
		// loop all the dialogs in the modal container:
		container.find("[data-modaldialog]").each(function () {
			const item = $(this); // Get the current modal dialog element
			const name = item.attr("data-modaldialog"); // Get the name of the modal dialog
			dialog[name] = item; // Store the modal dialog element in the dialog object
		});

		return {
			container, // set container
			dialog // set dialog
		};
	}

	/**
	 * Set up event listeners for various modal interactions and initialize modal based on URL hash
	 * @returns {void}
	 */
	setupEvents() {
		const modal = this; // modal reference for use in nested functions (to avoid conflict with 'this' keyword)

		$(document).on("click", "[data-modal]", function (e) {
			e.preventDefault(); // prevent default action
			const $clickedElement = $(this); // cache the clicked element
			const target = $clickedElement.data("modal"); // get the target from the data attribute on the clicked element (either 'close' or the target dialog to show)
			const info = $clickedElement.data("modal-info");

			modal.show(target, info); // show the target dialog (or hide if target is 'close')
		});

		this.handleHashFragment(); // handle the hash fragment in the URL on first page load
		$(window).on("hashchange", () => this.handleHashFragment()); // detect changes to hash and run handleHashFragment
	}

	/**
	 * Handle the hash fragment in the URL to show the appropriate modal on first page load
	 * @returns {void}
	 */
	handleHashFragment() {
		let hash = window.location.hash.substring(1); // get the hash fragment from the URL without the leading '#'
		if (hash) {
			hash = hash === "download" ? "spider-download" : hash === "support" ? "spider-support" : hash; // adjust outlier cases
			if (this.elements.dialog[hash]) {
				this.show(hash); // show the modal if the hash matches a valid dialog
			}
		}
	}

	/**
	 * Show or hide the modal container based on the provided target
	 * @param {string|boolean} target - The target dialog to show, or false to hide the modal
	 * @param {string} info - Additional info to pass to the modal (optional)
	 * @returns {void}
	 */
	show(target, info = null) {
		let showModal = target && target !== "close" && this.elements.dialog[target]; // check if target exists and is valid
		let delay = 0;

		if (showModal && this.callbeforeShow && this.callbeforeShow[target]) {
			const valid = this.callbeforeShow[target](info, this); // call the beforeShow function for the target dialog (which will return false if invalid, or null/true if valid)
			showModal = valid === null ? true : valid; // if valid is null, set show to true, otherwise set show to the value of valid
		}

		// If we're trying to open a modal and one is already open
		if (showModal && this.current) {
			this.elements.container.hide(); // if we're trying to open a modal and one is already open, hide the container
			delay = 300; // set the delay to 300ms
		}

		this.current = showModal ? target : null; // set the current modal
		window.location.hash = showModal ? window.location.hash : ""; // clear the hash when the modal is closed

		// Show the targeted dialog and hide all others:
		for (let [key, item] of Object.entries(this.elements.dialog)) {
			showModal && key == target ? item.show() : item.hide();
		}

		setTimeout(() => {
			showModal ? this.elements.container.show() : this.elements.container.hide(); // show/hide the modal container (with a delay for the transition if modal is already open)
		}, delay);
	}
}
